import gql from 'graphql-tag';

const RESOURCE_FAVORITE_FRAGMENT = gql`
  fragment BaseResourceFavorite on Resource {
    favorite {
      id
      resourceId
    }
  }
`;

export default RESOURCE_FAVORITE_FRAGMENT;
